import { Skeleton } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 2px;
`;

export const SkeletonCard = styled(Skeleton)`
  height: 90px;
  border-radius: 4px;
`;
